export default class Images {
    constructor() {
        this._ = [];
        this.length = [];
    }
    getData() {
        return this._.map(it => it.getData());
    } 
    setData(d) {
        this._ = Array.isArray(d)
            ? d.map(it => {
                const { name, data, left, top, width,height } = it;
                return new Image(
                    name,
                    data,
                    parseInt(left) || 0,
                    parseInt(top) || 0,
                    parseInt(width) || 0,
                    parseInt(height) || 0
                );
            })
            : [];
        this.length = this._.length;
    }
    add(...d) {
        const annot = new Image(...d);
        this._.push(annot);
        return annot;
    }
    remove(annot) {
        const index = this.getIndexof(annot);
        if (index !== -1) {
            this._.splice(index, 1);
            this.length--;
        }
    }
    removeAll(imgs) {
        imgs.each((a) => {
            const index = this.getIndexof(a);
            a.wrapper.remove();
            if (index !== -1) {
                this._.splice(index, 1);
                this.length--;
            }
        });
    }
    getIndexof(img) {
        return this._.findIndex(f => f.code === img.code);
    }
}

class Image {
    constructor(name = '', data, left, top, width = 100, height=100) {
        this.name = name;
        this.type = 'image';
        this.top = Math.round(top);
        this.left = Math.round(left);
        this.height = Math.round(height);
        this.width = Math.round(width);
        this.data = data;
    }
    getData() {
        const { name, data, left, top, height, width } = this; 
        return { name, data, left, top, width, height  };
    }
    update(annot) {
        const { name, data, left, top, width } = annot;
        this.name = name;
        this.data = data;
        this.top = Math.round(top);
        this.left = Math.round(left); 
        if (width !== undefined ) { 
            const aspectRatio = this.height / this.width;
            this.width = Math.round(width);
            this.height = Math.round(width * aspectRatio);
        } 
    }
}